import { UserEnhancedApprovalFactory } from 'domain/approvals';

export const addUsersDataToTemplate = (template: Record<string, any>, users: any[]) => {
  const levels = template?.levels?.map(({ approvers, ...rest }: { approvers: any[]; [key: string]: unknown }) => ({
    ...rest,
    approvers: approvers.reduce((a: any[], v: any) => {
      const user = users.find((u: any) => u.id === v);
      if (user)
        return [
          ...a,
          UserEnhancedApprovalFactory({
            userGuid: user.username,
            tag: user.username,
            id: user.id,
            picture: user.avatar,
            fullName: user.fullName,
          }).toJS(),
        ];
      return a;
    }, []),
  }));
  return { ...template, levels };
};
